import { User } from "lucide-react";

import type { SidebarNavContext, SidebarNavSection } from "@/navigation/types";

const ACCOUNT_SIDEBAR_SECTIONS: SidebarNavSection[] = [
  {
    titleKey: "account.sections.personal",
    items: [
      {
        kind: "link",
        to: "/profile",
        end: true,
        labelKey: "settings.nav.profile",
        icon: User,
      },
    ],
  },
];

export function resolveAccountSidebarNav(_ctx: SidebarNavContext): SidebarNavSection[] {
  return ACCOUNT_SIDEBAR_SECTIONS;
}
